import yup from 'yup';
// translate
import messages from './messages';

export default yup.object({
  email: yup
    .string()
    .required(messages.validationRequiredEmail)
    .email(messages.validationEmail),
});



// WEBPACK FOOTER //
// ./src/components/Forgot/formRules.js